function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "filter-1"
}, /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceGraphic",
  type: "matrix",
  values: "0 0 0 0 0.854902 0 0 0 0 0.850980 0 0 0 0 0.870588 0 0 0 1.000000 0"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Pagina's---Web-app",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "White---Product-start",
  transform: "translate(-30.000000, -213.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "list_black_24dp",
  transform: "translate(27.000000, 120.000000)",
  filter: "url(#filter-1)"
}, /*#__PURE__*/React.createElement("g", {
  transform: "translate(0.000000, 86.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  points: "0 0 26.01 0 26.01 26.01 0 26.01"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "Path",
  opacity: 0.87,
  points: "0 0 26.01 0 26.01 26.01 0 26.01"
})), /*#__PURE__*/React.createElement("path", {
  d: "M3.25125,14.08875 L5.41875,14.08875 L5.41875,11.92125 L3.25125,11.92125 L3.25125,14.08875 Z M3.25125,18.42375 L5.41875,18.42375 L5.41875,16.25625 L3.25125,16.25625 L3.25125,18.42375 Z M3.25125,9.75375 L5.41875,9.75375 L5.41875,7.58625 L3.25125,7.58625 L3.25125,9.75375 Z M7.58625,14.08875 L22.75875,14.08875 L22.75875,11.92125 L7.58625,11.92125 L7.58625,14.08875 Z M7.58625,18.42375 L22.75875,18.42375 L22.75875,16.25625 L7.58625,16.25625 L7.58625,18.42375 Z M7.58625,7.58625 L7.58625,9.75375 L22.75875,9.75375 L22.75875,7.58625 L7.58625,7.58625 Z M3.25125,14.08875 L5.41875,14.08875 L5.41875,11.92125 L3.25125,11.92125 L3.25125,14.08875 Z M3.25125,18.42375 L5.41875,18.42375 L5.41875,16.25625 L3.25125,16.25625 L3.25125,18.42375 Z M3.25125,9.75375 L5.41875,9.75375 L5.41875,7.58625 L3.25125,7.58625 L3.25125,9.75375 Z M7.58625,14.08875 L22.75875,14.08875 L22.75875,11.92125 L7.58625,11.92125 L7.58625,14.08875 Z M7.58625,18.42375 L22.75875,18.42375 L22.75875,16.25625 L7.58625,16.25625 L7.58625,18.42375 Z M7.58625,7.58625 L7.58625,9.75375 L22.75875,9.75375 L22.75875,7.58625 L7.58625,7.58625 Z",
  id: "Shape",
  fill: "#000000",
  fillRule: "nonzero"
})))));

function SvgList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "list_black_24dp") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/list.8f281982.svg";
export { ForwardRef as ReactComponent };